interface FocusAreaSelectorProps {
  selected: string;
  onSelect: (area: string) => void;
}

const FOCUS_AREAS = [
  { id: 'confidence', label: 'Confidence', icon: '💪', color: '#6366f1' },
  { id: 'resilience', label: 'Resilience', icon: '🌟', color: '#8b5cf6' },
  { id: 'growth', label: 'Growth', icon: '🌱', color: '#22c55e' },
  { id: 'gratitude', label: 'Gratitude', icon: '🙏', color: '#f59e0b' },
  { id: 'calm', label: 'Calm', icon: '🧘', color: '#14b8a6' },
  { id: 'success', label: 'Success', icon: '🏆', color: '#ec4899' },
];

export function FocusAreaSelector({ selected, onSelect }: FocusAreaSelectorProps) {
  return (
    <div className="mb-6">
      <p className="text-sm text-gray-600 mb-3 text-center">
        Choose a focus area for your affirmation:
      </p>
      <div className="flex flex-wrap justify-center gap-2">
        {FOCUS_AREAS.map((area) => (
          <button
            key={area.id}
            onClick={() => onSelect(area.id === selected ? '' : area.id)}
            className={`chip ${selected === area.id ? 'selected' : ''}`}
            style={selected === area.id ? { backgroundColor: area.color } : {}}
          >
            <span>{area.icon}</span>
            <span>{area.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
